import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg24X24WorkorderOutline = function Svg24X24WorkorderOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 12.2V16a1 1 0 0 0 1 1 1 1 0 1 1 0 2H2a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-3.8c0-2.752 1.93-5.143 4.766-6.355A2 2 0 0 1 9.76 4h4.48a2 2 0 0 1 1.994 1.845C19.07 7.057 21 9.448 21 12.2m-16 0V16c0 .35-.06.687-.17 1h14.34c-.11-.313-.17-.65-.17-1v-3.8c0-1.755-1.231-3.38-3.143-4.33l-.55 2.357a1 1 0 0 1-1.947-.454L14.24 6H9.76l.88 3.773a1 1 0 0 1-1.947.454l-.55-2.357C6.23 8.82 5 10.445 5 12.2",
    clipRule: "evenodd"
  })));
};
export default Svg24X24WorkorderOutline;